document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".custom-card-slider").forEach((el) => {
    const swiper = new Swiper(el, {
      slidesPerView: 1,
      loop: true,
      speed: 600, // smooth transition speed
      navigation: {
        nextEl: el.querySelector(".swiper-button-next"),
        prevEl: el.querySelector(".swiper-button-prev"),
      },
    });

    // Hover → smoothly go to 2nd image
    el.addEventListener("mouseenter", () => {
      if (swiper.slides.length > 1) {
        swiper.slideToLoop(1, 600); // 600ms transition to 2nd image
      }
    });

    // Mouse leave → smoothly return to 1st image
    el.addEventListener("mouseleave", () => {
      swiper.slideToLoop(0, 600); // 600ms transition back to 1st image
    });
  });
});